"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SITPV_TYPICAL_PATIENT = void 0;
/**
 * Typical patient per species (Javier, 2026-09-18). Measured from our own visits — weight and
 * age on the day of each visit, last 24 months, only patients who received one of the 41
 * controlled articles — and rounded: dog trimmed mean 12.1 kg / 86 months, cat 4.1 kg / 40 months.
 * Source: `resources/notes/sitpv/paciente-tipo-20260918.txt`. Re-measure yearly with the same
 * query. The app proposes it; the reviewer can change it before the portal preview.
 */
exports.SITPV_TYPICAL_PATIENT = {
    CANINO: { sitpvSpeciesId: 16, weightKg: 10, ageMonths: 84 },
    FELINO: { sitpvSpeciesId: 27, weightKg: 4, ageMonths: 40 },
};
